/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Tab_TasksInputs */

const cs_pipelines_tab_tasks = /** @type {(inputs: Pipelines_Tab_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkoly`)
};

const en_pipelines_tab_tasks = /** @type {(inputs: Pipelines_Tab_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasks`)
};

/**
* | output |
* | --- |
* | "Tasks" |
*
* @param {Pipelines_Tab_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_tab_tasks = /** @type {((inputs?: Pipelines_Tab_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Tab_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_tab_tasks(inputs)
	return cs_pipelines_tab_tasks(inputs)
});